import React from "react"
import TableCell from "@mui/material/TableCell"
import TableRow from "@mui/material/TableRow"
import Checkbox from "@mui/material/Checkbox"
import { limitString } from "../../../util/tableUtils"
import { makeStyles } from "@material-ui/core"
import { DATA_TYPES } from "../../../util/filters/filterConstants"

const useStyles = makeStyles({
  rowSelected: {
    "&:hover": {
      backgroundColor: "#c8e6fc",
    },
    backgroundColor: "#EDF7FE",
  },
  rowNotSelected: {
    "&:hover": {
      backgroundColor: "rgba(0,0,0,0.1) !important",
    },
    backgroundColor: "white",
  },
})

export default function CustomTableRow(props) {
  const { row, headers, clickAction, isSelected, onSelectClick, checkBoxes, filterManager } = props
  const classes = useStyles()
  const isItemSelected = isSelected ? isSelected(row.id) : false

  const formatCell = (data, filterType) => {
    const filter = filterManager.getFilter(filterType)
    let formattedData
    switch (filter.dataType) {
      case DATA_TYPES.PERCENT:
        formattedData = `${data.toString()}%`
        break
      case DATA_TYPES.STRING:
        formattedData = limitString(data, 50)
        break
      case DATA_TYPES.LIST:
        formattedData = limitString(data.join(", "), 200)
        break
      case DATA_TYPES.ELEMENT:
        formattedData = data.element
        break
      default:
        return data
    }

    if (filter.allowCompare) {
      const relevantFilter = filterManager.getFilter(filter.compareWith)
      const possibleValues = row[filter.compareWith].filter((x) =>
        x.toLowerCase().includes(relevantFilter.value),
      )
      return possibleValues.length === 0 ||
        formattedData === possibleValues[0] ||
        !relevantFilter.value
        ? formattedData
        : `${formattedData} (${filter.comparisonFailurePrefix} ${possibleValues[0]})`
    }

    return formattedData
  }

  const formatAlign = (type) => {
    switch (type) {
      case DATA_TYPES.ELEMENT:
        return "center"
      default:
        return "left"
    }
  }

  return (
    <TableRow
      className={isItemSelected ? classes.rowSelected : classes.rowNotSelected}
      onClick={row.no_click ? () => {} : (event) => clickAction(event, row)}
      tabIndex={-1}
      key={row.id}
      sx={row.no_click ? { cursor: "default" } : { cursor: "pointer" }}
    >
      {checkBoxes ? (
        <TableCell onClick={(event) => event.stopPropagation()} size="small">
          <Checkbox
            color="primary"
            checked={isItemSelected}
            onClick={(event) => onSelectClick(event, row.id)}
          />
        </TableCell>
      ) : null}

      {headers
        .filter((header) => header.display)
        .map((header) => {
          return (
            <TableCell key={header.id} align={formatAlign(header.type)}>
              {formatCell(row[header.id], header.id)}
            </TableCell>
          )
        })}
    </TableRow>
  )
}
